import React from "react";
import { Link } from "react-router-dom";
import {
  Code,
  CheckCircle,
  Zap,
  Database,
  Globe,
  ExternalLink,
} from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const DeveloppementWeb = () => {
  return (
    <div className="font-sans min-h-screen bg-gray-50">
      <Header />

      {/* Hero Section */}
      <section className="relative min-h-[500px] flex items-center justify-center overflow-hidden">
        {/* Background Image */}
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: "url(/images/dev-web/87456.jpg)" }}
        ></div>
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-black to-flowkraft-primary opacity-90"></div>

        <div className="container mx-auto px-4 relative z-10 py-20">
          <div className="flex items-center justify-center mb-8">
            <Code className="w-16 h-16 text-flowkraft-secondary" />
          </div>
          <h1 className="text-4xl md:text-6xl font-bold text-center mb-6 text-white">
            Développement Web
          </h1>
          <p className="text-xl text-center text-gray-200 max-w-3xl mx-auto">
            Applications web modernes et performantes avec les technologies de
            pointe
          </p>
        </div>
      </section>

      {/* Description */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4 max-w-4xl">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">
            Notre Expertise
          </h2>
          <p className="text-lg text-gray-700 mb-4">
            Nous concevons et développons des applications web sur mesure qui
            répondent parfaitement à vos besoins métier. Notre équipe maîtrise
            les dernières technologies pour créer des solutions robustes,
            scalables et performantes.
          </p>
          <p className="text-lg text-gray-700">
            De la simple vitrine au SaaS complexe, nous accompagnons votre
            projet de la conception à la mise en production et au-delà.
          </p>
        </div>
      </section>

      {/* Services Proposés */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4 max-w-6xl">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
            Nos Services de Développement Web
          </h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white rounded-xl p-8 shadow-lg">
              <Globe className="w-12 h-12 text-flowkraft-primary mb-4" />
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Progressive Web Apps
              </h3>
              <p className="text-gray-700 mb-4">
                Applications web progressives offrant une expérience native sur
                tous les appareils.
              </p>
              <ul className="space-y-2">
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Mode hors ligne
                </li>
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Notifications push
                </li>
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Installation sur l'écran d'accueil
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg">
              <Zap className="w-12 h-12 text-flowkraft-primary mb-4" />
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                E-commerce
              </h3>
              <p className="text-gray-700 mb-4">
                Solutions complètes de vente en ligne avec paiement sécurisé et
                gestion des stocks.
              </p>
              <ul className="space-y-2">
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Paiement sécurisé
                </li>
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Gestion des commandes
                </li>
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Tableaux de bord analytics
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg">
              <Code className="w-12 h-12 text-flowkraft-primary mb-4" />
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                CMS Personnalisés
              </h3>
              <p className="text-gray-700 mb-4">
                Systèmes de gestion de contenu adaptés à vos besoins
                spécifiques.
              </p>
              <ul className="space-y-2">
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Interface intuitive
                </li>
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Gestion multi-utilisateurs
                </li>
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Workflows personnalisés
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg">
              <Database className="w-12 h-12 text-flowkraft-primary mb-4" />
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                API REST/GraphQL
              </h3>
              <p className="text-gray-700 mb-4">
                Conception et développement d'APIs robustes et documentées.
              </p>
              <ul className="space-y-2">
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Architecture scalable
                </li>
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Documentation automatique
                </li>
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Tests automatisés
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Technologies */}
      {/* <section className="py-16 bg-white">
        <div className="container mx-auto px-4 max-w-6xl">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
            Technologies Utilisées
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {["React", "Vue.js", "Next.js", "Node.js", "TypeScript", "Tailwind CSS", "MongoDB", "PostgreSQL"].map((tech) => (
              <div key={tech} className="bg-gray-50 rounded-lg p-6 text-center hover:shadow-lg transition-shadow">
                <p className="font-semibold text-gray-900">{tech}</p>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* Réalisations */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4 max-w-6xl">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
            Nos Réalisations Web
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            {/* Projet 1 */}
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-flowkraft-xl transition-shadow duration-300">
              <div className="h-48 bg-gradient-to-r from-flowkraft-primary to-flowkraft-secondary flex items-center justify-center overflow-hidden">
                <img
                  src="/images/dev-web/354484.png"
                  alt="GCSGC Agency - Refonte Site Web"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  GCSGC Agency - Refonte Site Web
                </h3>
                <p className="text-gray-600 mb-4">
                  Refonte complète du site web de l'agence GCSGC avec design
                  moderne et optimisation des performances
                </p>
                {/* <div className="flex flex-wrap gap-2 mb-4">
                  <span className="bg-flowkraft-primary bg-opacity-10 text-flowkraft-primary px-3 py-1 rounded-full text-sm font-medium">
                    React
                  </span>
                  <span className="bg-flowkraft-primary bg-opacity-10 text-flowkraft-primary px-3 py-1 rounded-full text-sm font-medium">
                    Tailwind CSS
                  </span>
                  <span className="bg-flowkraft-primary bg-opacity-10 text-flowkraft-primary px-3 py-1 rounded-full text-sm font-medium">
                    Node.js
                  </span>
                </div> */}
              </div>
            </div>

            {/* Projet 2 */}
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-flowkraft-xl transition-shadow duration-300">
              <div className="h-48 bg-gradient-to-r from-flowkraft-primary to-flowkraft-secondary flex items-center justify-center overflow-hidden">
                <img
                  src="/images/dev-web/flor.png"
                  alt="Portfolio Flora"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  Portfolio Flora
                </h3>
                <p className="text-gray-600 mb-4">
                  Conception d'un portfolio professionnel personnalisé avec
                  design élégant et expérience utilisateur optimale
                </p>
                {/* <div className="flex flex-wrap gap-2 mb-4">
                  <span className="bg-flowkraft-primary bg-opacity-10 text-flowkraft-primary px-3 py-1 rounded-full text-sm font-medium">
                    React
                  </span>
                  <span className="bg-flowkraft-primary bg-opacity-10 text-flowkraft-primary px-3 py-1 rounded-full text-sm font-medium">
                    Tailwind CSS
                  </span>
                </div> */}
              </div>
            </div>

            {/* Projet 3 avec lien */}
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-flowkraft-xl transition-shadow duration-300">
              <div className="h-48 bg-gradient-to-r from-flowkraft-primary to-flowkraft-secondary flex items-center justify-center overflow-hidden">
                <img
                  src="/images/dev-web/1.png"
                  alt="SalonHub SaaS"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  SalonHub
                </h3>
                <p className="text-gray-600 mb-4">
                  Application web SaaS de gestion pour salons de coiffure et
                  instituts de beauté avec réservation en ligne
                </p>
                {/* <div className="flex flex-wrap gap-2 mb-4">
                  <span className="bg-flowkraft-primary bg-opacity-10 text-flowkraft-primary px-3 py-1 rounded-full text-sm font-medium">
                    React
                  </span>
                  <span className="bg-flowkraft-primary bg-opacity-10 text-flowkraft-primary px-3 py-1 rounded-full text-sm font-medium">
                    TypeScript
                  </span>
                  <span className="bg-flowkraft-primary bg-opacity-10 text-flowkraft-primary px-3 py-1 rounded-full text-sm font-medium">
                    Node.js
                  </span>
                </div> */}
                <a
                  href="https://salonhub.flowkraftagency.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center text-flowkraft-primary hover:text-flowkraft-secondary font-semibold transition-colors"
                >
                  Voir le projet <ExternalLink className="w-4 h-4 ml-1" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="relative py-20 overflow-hidden">
        {/* Background Image */}
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: "url(/images/main/2149755776.jpg)" }}
        ></div>
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-flowkraft-primary to-black opacity-90"></div>

        <div className="container mx-auto px-4 text-center relative z-10">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white">
            Prêt à démarrer votre projet web ?
          </h2>
          <p className="text-xl mb-8 text-gray-200">
            Contactez-nous pour discuter de vos besoins
          </p>
          <Link
            to="/#contact"
            className="inline-block bg-white text-flowkraft-primary px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-colors"
          >
            Demander un devis
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default DeveloppementWeb;
